import { jsx as _jsx } from "react/jsx-runtime";
import { AdSlotIds } from "@/shared/types";
import { AdContainer } from "./AdContainer";
import { useFarbwelt } from "@/hooks";
import { useIsNewBuildProject } from "@/shared/hooks";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const AdBannerMobile = () => {
    const { isFarbweltActive } = useFarbwelt();
    const isPreviewMode = useIsPreviewMode();
    const isProject = useIsNewBuildProject();
    if (isFarbweltActive || isPreviewMode || isProject) {
        return null;
    }
    return (_jsx(AdContainer, { adSlotId: AdSlotIds.AD_BANNER_MOBILE, width: "100%", height: "150px", display: {
            "breakpoint.base": "flex",
            "breakpoint.lg": "none",
        }, showLabel: true, showFallback: true }));
};
